import axios from "axios";
import { clearIdentity, getAuth } from "@/server/authStorage";

// Instância personalizada do axios
const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 20000,
  withCredentials: false,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

const clearUserSession = () => {
  clearIdentity();
};

const redirectToLogin = () => {
  if (typeof window !== "undefined") window.location.href = "/login";
};

// ---------------------------------------------------------------------------
// Request interceptor — injeta o token correto
// O token do usuário persiste no localStorage por 30 dias. Rotas de
// pré-autenticação usam skipUserToken para não receber o Bearer do usuário.
// ---------------------------------------------------------------------------
instance.interceptors.request.use(
  (config) => {
    const auth = getAuth();

    if (!config.skipUserToken && auth?.access_token) {
      config.headers["Authorization"] = `Bearer ${auth.access_token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// ---------------------------------------------------------------------------
// Um Bearer recusado encerra a sessão. O login só pode emitir outro token
// depois de uma nova confirmação OTP; não há retry nem bootstrap público.
// ---------------------------------------------------------------------------
instance.interceptors.response.use(
  (response) => response.data, // unwrap para todos os serviços receberem body direto

  async (error) => {
    const status = error.response?.status ?? null;
    const errorCode = error.response?.data?.code ?? null;

    if (status !== 401 || errorCode !== "AUTH_TOKEN_INVALID") {
      return Promise.reject(error);
    }

    const auth = getAuth();
    if (auth?.access_token && !error.config?.skipUserToken) {
      clearUserSession();
      redirectToLogin();
    }

    return Promise.reject(error);
  }
);

export default instance;
